import { BillingTerminals } from './billing-terminals.models';
import { Pagination } from './core.models';
import { Establishment } from './establishment.model';
import { FreeRequestParams } from './shared.models';

export enum BillingEquipment {
  fnePlatform = 'fne_platform',
  termeFne = 'terme_fne',
  appsMobileRne = 'apps_mobile_rne',
  apiFne = 'api_fne'
}

export enum OnboardingBillingEquipment {
  onboardingEquipmentType = 'onboarding_equipment_type',
  billingSoftware = 'billing_software'
}

export type SalesPoint = {
  id: string;
  name: string;
  billingEquipment: BillingEquipment;
  billingTerminalId?: string;
  billingTerminals?: BillingTerminals[];
  establishment?: Establishment;
  description?: string;
  enabled: boolean;
  metadata: unknown[];
  createdAt: string;
  updatedAt: string;
  associatedBillingTerminals: number;
};

export type ListSalesPointRequestParams = {
  name?: string;
  establishmentId?: string;
  enabled?: boolean;
  createdAt?: string;
  updatedAt?: string;
} & FreeRequestParams;

export type CreateSalesPointParams = {
  name: string;
  establishmentId: string;
  billingEquipment?: BillingEquipment | string;
  billingTerminalId?: string;
  description?: string;
  enabled?: boolean;
};

export type UpdateSalesPointParams = Partial<CreateSalesPointParams>;

export type SalesPointListResponse = Pagination<SalesPoint>;

export type SalesPointImportParams = {
  organizationId: string;
  file: Blob | File;
};
